var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 2.60418C10.4165 2.31653 10.6497 2.08334 10.9373 2.08334H14.0623C14.35 2.08334 14.5832 2.31653 14.5832 2.60418V18.75C14.5832 19.0377 14.35 19.2708 14.0623 19.2708H10.9373C10.6497 19.2708 10.4165 19.0377 10.4165 18.75V2.60418Z",
    fill: "#CD6EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68734 10.9375C4.39969 10.9375 4.1665 11.1707 4.1665 11.4583V18.75C4.1665 19.0377 4.39969 19.2708 4.68734 19.2708H7.81234C8.09999 19.2708 8.33317 19.0377 8.33317 18.75V11.4583C8.33317 11.1707 8.09999 10.9375 7.81234 10.9375H4.68734Z",
    fill: "#CD6EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9168 20.8333H2.0835V22.9167H22.9168V20.8333Z",
    fill: "#CD6EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1873 6.77084C16.8997 6.77084 16.6665 7.00402 16.6665 7.29168V18.75C16.6665 19.0377 16.8997 19.2708 17.1873 19.2708H20.3123C20.6 19.2708 20.8332 19.0377 20.8332 18.75V7.29168C20.8332 7.00402 20.6 6.77084 20.3123 6.77084H17.1873Z",
    fill: "#CD6EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartFill);
export default __webpack_public_path__ + "static/media/bar_chart_fill.2b77d5a4c3696b7a93a12742bc4b3976.svg";
export { ForwardRef as ReactComponent };